import React from 'react';
import { useLoopingCountdown } from '../hooks/useLoopingCountdown';
const TOTAL = 17 * 60 + 34;
export function CountdownTimer() {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown(TOTAL);
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div className="w-full max-w-xl rounded-2xl bg-red-600 px-4 py-4 text-white" role="timer" aria-live="off" data-id="element-105" data-mp="1oafltez7roge">
      <p className="text-center text-sm font-extrabold uppercase tracking-wider" data-id="element-106" data-mp="1k8kdvrms2ctn">
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" data-id="element-107" data-mp="1abxr2xaw5boz">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-108" data-mp="15epk7sv70u31" data-mpi={i}>
            <div className="flex w-20 flex-col items-center rounded-xl bg-white py-2 sm:w-24" data-id="element-109" data-mp="15fqx82vrrqne">
              <span className="font-mono text-3xl font-extrabold tabular-nums text-red-600 sm:text-4xl" data-id="element-110" data-mp="34onwab6pm7bo">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="text-[11px] font-bold uppercase tracking-wide text-navy-900" data-id="element-111" data-mp="1bz3tamzytuqr">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="text-3xl font-extrabold" data-id="element-112" data-mp="122qzzq8c1iwj">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}